(function () {
  const filtersContainer = document.querySelector("#api-cards-container .card-filters");
  const myApisFilter = "My APIs";
  if (!filtersContainer) {
    // Return if we are not in the API filters page.
    return;
  }

  const globalFilterId = document.body.getAttribute("globalFilter");
  if (globalFilterId) {
    const globalFilterItems = document.querySelectorAll("#global-filter .select-value");
    for (let selectList = 0; selectList < globalFilterItems.length; selectList++) {
      globalFilterItems[selectList].addEventListener("click", () => {
        initFilters();
      });
    }
  }

  initFilters();

  /**
   * Initialize filters.
   */
  function initFilters() {
    const globalFilterId = document.body.getAttribute("globalFilter");
    let globalFilter;
    if (globalFilterId) {
      globalFilter = globalFilters?.find((filter) => filter.filterId === globalFilterId);
    }
    let modeQueryParameter;
    const legendContainer = document.querySelector(".active-filters-legend");
    const filterData = {
      productLine: new Set(),
      vertical: new Set(),
      tag: new Set(),
      resourceType: new Set(),
    };
    let activeFilters = {};

    // Extract filter values from the card's data attributes and add them to the respective filterData sets.
    const listItems = document.querySelectorAll("figure.card-tile");
    listItems.forEach((card) => {
      Object.keys(filterData).forEach((filter) => {
        card.dataset[filter]?.split(",").forEach((filterValue) => {
          if (filter === "productLine" && globalFilterId && globalFilterId !== "global" && !globalFilter.productLines.includes(filterValue)) {
            return;
          }
          filterData[filter].add(filterValue.trim());
        });
      });
    });

    let userCredentials = [];
    const token = Cookies.get("TOKEN");
    if (token) {
      filterData.resourceType.add(myApisFilter);
      fetch("https://dashboard.accounts.developer.siemens.com/proxy/api/credentials/v1/user/credentials", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          userCredentials = data.filter((p) => p.revoked == false && (p.validUntil == null || new Date(p.validUntil).getTime() >= new Date().getTime()));

          listItems.forEach((card) => {
            if (userCredentials.some((p) => p.packageName == card.dataset.packageName)) {
              card.dataset.accessAvailable = "true";
            }
          });

          const cardsContainer = document.querySelector(".api-cards");
          const sortedItems = Array.from(listItems).sort((a, b) => {
            if (a.dataset.accessAvailable && !b.dataset.accessAvailable) {
              return -1;
            } else {
              return 1;
            }
          });
          sortedItems.forEach((item) => {
            cardsContainer.appendChild(item);
          });
        });
    }

    // Group verticals, tags and resource types under the product line, so we can disable them when the result set would be empty.
    const productLines = [];
    listItems.forEach((card) => {
      const productLine = card.dataset.productLine;
      if (!productLines[productLine]) {
        productLines[productLine] = {
          vertical: new Set(),
          tag: new Set(),
          resourceType: new Set(),
        };
      }
      card.dataset.vertical.split(",").forEach((filterValue) => productLines[productLine].vertical.add(filterValue.trim()));
      card.dataset.tag.split(",").forEach((filterValue) => productLines[productLine].tag.add(filterValue.trim()));
      card.dataset.resourceType.split(",").forEach((filterValue) => productLines[productLine].resourceType.add(filterValue.trim()));
    });

    // Sort filters.
    filterData.productLine = new Set(
      [...filterData.productLine].sort((a, b) => {
        // Put product lines ending with " X" at the top.
        if (a.endsWith(" X") && !b.endsWith(" X")) {
          return -1;
        } else if (!a.endsWith(" X") && b.endsWith(" X")) {
          return 1;
        } else if (a.toLowerCase().includes("example") && !b.toLowerCase().includes("example")) {
          return 1;
        } else if (!a.toLowerCase().includes("example") && b.toLowerCase().includes("example")) {
          return -1;
        } else {
          return a.localeCompare(b);
        }
      }),
    );

    filterData.vertical = new Set([...filterData.vertical].sort());

    filterData.tag = new Set(
      [...filterData.tag].sort((a, b) => {
        if (a.endsWith(" X") && !b.endsWith(" X")) {
          return -1;
        } else if (!a.endsWith(" X") && b.endsWith(" X")) {
          return 1;
        } else {
          return a.localeCompare(b);
        }
      }),
    );
    filterData.resourceType = new Set(
      [...filterData.resourceType].sort((a, b) => {
        if (a == myApisFilter && b != myApisFilter) {
          return -1;
        } else if (a.endsWith("API") && !b.endsWith("API")) {
          return -1;
        } else if (!a.endsWith("API") && b.endsWith("API")) {
          return 1;
        } else {
          return a.localeCompare(b);
        }
      }),
    );

    const filterControls = document.createElement("div");
    filterControls.classList.add("filter-controls");

    const sortItems = document.querySelectorAll(".sorting .select-items div");
    const elemLen = sortItems.length;
    for (let listIndex = 0; listIndex < elemLen; listIndex++) {
      sortItems[listIndex].addEventListener("click", function () {
        /* when an item is clicked, update the original select box, and the selected item */
        window.updateSelectList(this);

        const cardsContainer = document.querySelector(".cards");
        const sortSelect = document.querySelector(".sorting .custom-selected");
        const value = sortSelect.getAttribute("value");
        // value is not default then only sort
        if (value !== 0) {
          const sortedItems = Array.from(listItems).sort((a, b) => {
            const aValue = a.dataset[value]?.split(",")[0].trim();
            const bValue = b.dataset[value]?.split(",")[0].trim();

            // When sorting by product line, put product lines ending with " X" at the top.
            if (value === "productLine") {
              if (aValue.endsWith(" X") && !bValue.endsWith(" X")) {
                return -1;
              } else if (!aValue.endsWith(" X") && bValue.endsWith(" X")) {
                return 1;
              }
            }

            // Put non-empty values first.
            if (!aValue || !bValue) {
              return aValue ? -1 : bValue ? 1 : 0;
            }

            // Sort alphabetically.
            return aValue.localeCompare(bValue);
          });

          sortedItems.forEach((item) => {
            cardsContainer.appendChild(item);
          });
        }

        updateFilters();
      });
    }

    const searchBox = document.querySelector("#search-box");
    searchBox.addEventListener("input", function () {
      updateFilters();
      updateURL();
    });

    /**
     * Closes filter section.
     *
     * @param {Element} filterSection - The filter section element that should be closed.
     */
    function closeSection(filterSection) {
      filterSection.removeAttribute("open");
    }

    /**
     * Closes all filter sections except the one currently selected.
     *
     * @param {Element} current - The filter section element that should remain open.
     */
    function closeAllExcept(current) {
      document.querySelectorAll("details.filter-section").forEach((detail) => {
        if (detail !== current) {
          closeSection(detail);
        }
      });
    }

    /**
     * Converts a camelCase filter name into a space-separated string with each word capitalized.
     *
     * @param {string} filter - The camelCase string representing the filter name.
     * @return {string} The converted string with spaces and capitalization.
     */
    function getFilterHeading(filter) {
      return filter.replace(/([A-Z])/g, " $1").replace(/^\w/, (c) => c.toUpperCase());
    }

    /**
     * Removes an active filter based on its key and value.
     *
     * @param {string} filterKey - The key of the filter to be removed.
     * @param {string} filterValue - The value of the filter to be removed.
     */
    function removeActiveFilter(filterKey, filterValue) {
      filters.forEach((filter) => {
        // ignoring default product filter in fds
        if (globalFilterId === "fds" && filter.value === "Foundational Services") {
          return;
        } else {
          if (filter.name === filterKey && filter.value === filterValue) {
            filter.checked = false;
            filter.setAttribute("aria-checked", "false");
          }
        }
      });
      updateFilters();
      updateURL();
      updateCheckboxCount();
    }

    /**
     * Updates the count of checked checkboxes for each filter section.
     */
    function updateCheckboxCount() {
      document.querySelectorAll(".filter-section").forEach((section) => {
        const summary = section.querySelector("summary");
        const checkboxes = section.querySelectorAll("input[type=checkbox]");
        const checkedCount = Array.from(checkboxes).filter((cb) => cb.checked).length;

        // Update the display next to the <h3> element.
        let countDisplay = summary.querySelector(".checked-count");
        if (!countDisplay) {
          countDisplay = document.createElement("span");
          countDisplay.classList.add("checked-count");
          summary.querySelector("h3").appendChild(countDisplay);
        }
        if (checkedCount > 0) {
          countDisplay.textContent = ` (${checkedCount})`;
        } else {
          countDisplay.textContent = "";
        }
      });
    }

    /**
     * Creates and returns an array of HTML elements representing the active filters.
     *
     * @return {HTMLElement[]} An array of div elements, each representing a group of active filter values.
     */
    function renderActiveFiltersLegend() {
      const legendHTML = [];
      let isProductLine = true;
      Object.entries(activeFilters).forEach(([filterKey, filterValues]) => {
        // Do not show the product line in this mode.
        if (!isProductLine || modeQueryParameter !== "hideunselected") {
          if (filterValues.length > 0) {
            const legendElement = document.createElement("div");
            legendElement.classList.add("active-filter-group");
            legendElement.textContent = getFilterHeading(filterKey);

            for (const filterValue of filterValues) {
              const clickableFilterValueElement = document.createElement("span");
              clickableFilterValueElement.classList.add("clickable-filter");
              clickableFilterValueElement.textContent = filterValue;
              clickableFilterValueElement.onclick = () => {
                removeActiveFilter(filterKey, filterValue);
              };
              legendElement.appendChild(clickableFilterValueElement);
            }
            legendHTML.push(legendElement);
          }
        }
        isProductLine = false;
      });
      return legendHTML;
    }

    /**
     * Filters and updates the display of filters hiding elements that do not include the specified filter text.
     *
     * @param {HTMLElement} container - The container element that holds the div elements to be filtered.
     * @param {string} filterText - The text used for filtering the div elements.
     */
    function filterAndDisplayDivs(container, filterText) {
      const divs = Array.from(container.children);
      divs.forEach((div) => {
        if (filterText.length === 0 || div.textContent.toLowerCase().includes(filterText.toLowerCase())) {
          div.style.display = "";
        } else {
          div.style.display = "none";
        }
      });
    }

    // Generate filter sections in the filters container.
    filtersContainer.innerHTML = "";
    Object.entries(filterData).forEach(([filter, filterValues]) => {
      const filterSection = document.createElement("details");
      filterSection.classList.add("filter-section");

      filterSection.addEventListener("toggle", function (e) {
        const search = e.target.querySelector('input[type="search"]');
        if (filterSection.open) {
          closeAllExcept(filterSection);
          search.focus();
        } else {
          search.value = "";
          filterAndDisplayDivs(e.target.querySelector(".filter-list"), "");
        }
      });

      let closeTimeout;
      filterSection.addEventListener("mouseleave", function () {
        // Set a timeout to close it, so it is not closed unexpectetly.
        closeTimeout = setTimeout(() => closeSection(filterSection), 500);
      });
      filterSection.addEventListener("mouseenter", function () {
        clearTimeout(closeTimeout);
      });

      const heading = document.createElement("h3");
      const headingText = getFilterHeading(filter);
      // Verticals are now called "Industries" in Marketplace
      heading.textContent = headingText === "Vertical" ? "Industry" : headingText;
      // Product lines are called Products in Marketplace
      heading.textContent = headingText === "Product Line" ? "Product" : headingText;
      const summary = document.createElement("summary");

      summary.appendChild(heading);
      filterSection.appendChild(summary);
      const detailsFilterWrapper = document.createElement("div");
      detailsFilterWrapper.classList.add("filter-wrapper");
      const filterWrapperList = document.createElement("div");
      filterWrapperList.classList.add("filter-list");

      const FilterWrapperSearch = document.createElement("input");
      FilterWrapperSearch.type = "search";
      FilterWrapperSearch.placeholder = "Search...";
      FilterWrapperSearch.addEventListener("input", () => {
        filterAndDisplayDivs(filterWrapperList, FilterWrapperSearch.value);
      });
      detailsFilterWrapper.appendChild(FilterWrapperSearch);

      // Generate checkboxes and labels for each filter value.
      for (const value of filterValues) {
        const input = document.createElement("input");
        const checkboxId = filter + "-" + value.replaceAll(" ", "-");
        input.id = checkboxId;
        input.type = "checkbox";
        input.setAttribute("aria-checked", "false");
        input.setAttribute("aria-labelledby", `label-${checkboxId}`);
        input.name = filter;
        input.value = value;
        input.addEventListener("click", () => {
          toggleBoolAttribute(input, "aria-checked");
          updateCheckboxCount();
        });

        const label = document.createElement("label");
        label.id = `label-${checkboxId}`;
        label.textContent = value;
        label.htmlFor = checkboxId;
        label.tabIndex = 0;
        label.addEventListener("keydown", (e) => {
          // Check if the key pressed was space (key code 32).
          if (e.code === "Space") {
            // Prevent the default action (scrolling the page).
            e.preventDefault();

            // Toggle the associated checkbox.
            document.getElementById(e.currentTarget.getAttribute("for")).click();
          }
        });

        const div = document.createElement("div");

        div.appendChild(input);
        div.appendChild(label);
        filterWrapperList.appendChild(div);
      }

      // Add the filter section to the filters container.
      detailsFilterWrapper.appendChild(filterWrapperList);
      filterSection.appendChild(detailsFilterWrapper);
      filtersContainer.appendChild(filterSection);
      filtersContainer.appendChild(filterControls);
    });

    const filters = document.querySelectorAll(".card-filters input[type=checkbox]");

    /**
     * Update the list of cards based on the selected filters.
     */
    function updateFilters() {
      let displayCount = 0;
      activeFilters = Object.fromEntries(Object.keys(filterData).map((key) => [key, []]));

      // Enable all filters, and add checked filters to the activeFilters object.
      filters.forEach((filter) => {
        filter.disabled = false;
        if (filter.checked) {
          activeFilters[filter.name].push(filter.value);
        }
      });

      // Disable filters that are incompatible with the selected product lines.
      filters.forEach((filter) => {
        if (filter.checked && filter.name === "productLine") {
          filters.forEach((otherFilter) => {
            if (otherFilter.name === "productLine") {
              return;
            }
            const shouldBeDisabled = activeFilters.productLine.every((productLine) => !productLines[productLine][otherFilter.name] || !productLines[productLine][otherFilter.name].has(otherFilter.value));
            otherFilter.disabled = shouldBeDisabled;
            if (shouldBeDisabled) {
              otherFilter.checked = false;
            }
          });
        }
      });
      updateCheckboxCount();

      // Reset the active filters object.
      activeFilters = Object.fromEntries(Object.keys(filterData).map((key) => [key, []]));
      filters.forEach((filter) => {
        if (filter.checked) {
          activeFilters[filter.name].push(filter.value);
        }
      });

      // Add legend of selected filters.
      legendContainer.innerHTML = "";
      const legendElements = renderActiveFiltersLegend();
      if (legendElements.length > 0) {
        for (const element of legendElements) {
          legendContainer.appendChild(element);
        }

        // Add "Clear All" button, but not in this mode.
        if (modeQueryParameter !== "hideunselected") {
          const clearAll = document.createElement("a");
          clearAll.href = "#";
          clearAll.textContent = "Clear All";
          clearAll.addEventListener("click", function (event) {
            event.preventDefault();
            filters.forEach((filter) => {
              // ignoring default product filter in fds
              if (globalFilterId === "fds" && filter.value === "Foundational Services") {
                return;
              } else {
                filter.checked = false;
                filter.setAttribute("aria-checked", "false");
              }
            });
            searchBox.value = "";
            updateFilters();
            updateURL();
            closeAllExcept(null);
            updateCheckboxCount();
          });
          legendContainer.appendChild(clearAll);
        }
      }

      const searchQuery = searchBox.value.toLowerCase();

      listItems.forEach((item) => {
        const header = item.querySelector(".card-header").textContent.toLowerCase();
        const body = item.querySelector(".card-body p").textContent.toLowerCase();
        const productLine = item.getAttribute("data-product-line").toLowerCase();
        const productLineUpperCase = item.getAttribute("data-product-line");
        const vertical = item.getAttribute("data-vertical").toLowerCase();
        const tags = [];
        item.querySelectorAll(".card-category").forEach((el) => {
          tags.push(el.textContent.toLowerCase());
        });

        const shouldDisplay =
          ((!globalFilterId || globalFilterId === "global" || globalFilter.productLines.includes(productLineUpperCase)) &&
            (header.includes(searchQuery) || body.includes(searchQuery) || tags.some((tag) => tag.includes(searchQuery)) || productLine.includes(searchQuery) || vertical.includes(searchQuery)) &&
            Object.entries(activeFilters).every(([filter, filterValues]) => {
              return filterValues.length === 0 || item.dataset[filter]?.split(",").some((filterValue) => filterValues.includes(filterValue.trim()));
            })) ||
          (activeFilters.resourceType.includes(myApisFilter) && userCredentials.some((p) => p.packageName == item.dataset.packageName));

        if (shouldDisplay) {
          item.style.display = "block";
          displayCount++;
        } else {
          item.style.display = "none";
        }

        // Sort filter by showing selected ones first.
        const filterLists = document.querySelectorAll(".filter-wrapper .filter-list");
        filterLists.forEach((list) => {
          const divs = Array.from(list.children);
          divs.sort((a, b) => {
            const checkboxA = a.querySelector('input[type="checkbox"]').checked;
            const checkboxB = b.querySelector('input[type="checkbox"]').checked;

            if (checkboxA && !checkboxB) {
              return -1;
            }
            if (!checkboxA && checkboxB) {
              return 1;
            }
            return 0;
          });
          divs.forEach((div) => list.appendChild(div));

          filterAndDisplayDivs(list, list.parentElement.querySelector("[type=search]").value);
        });
      });

      const results = document.querySelector(".card-listing-header .results");
      if (displayCount === 1) {
        results.textContent = "1 result";
      } else {
        results.textContent = `${displayCount} results`;
      }
    }

    /**
     * Get filters state from the URL.
     * @return {Object} The filters state.
     */
    function getStateFromURL() {
      const searchParams = new URLSearchParams(window.location.search);
      const state = {};
      filters.forEach((filter) => {
        if (searchParams.has(filter.name)) {
          state[filter.name] = searchParams.get(filter.name).split(",");
        }
      });
      if (searchParams.has("mode")) {
        modeQueryParameter = searchParams.get("mode");
      }

      if (searchParams.has("query")) {
        document.getElementById("search-box").value = searchParams.get("query");
        updateFilters();
      }

      return state;
    }

    /**
     * Update the URL with the filters state.
     */
    function updateURL() {
      const searchParams = new URLSearchParams();

      if (document.getElementById("search-box").value) {
        searchParams.set("query", document.getElementById("search-box").value);
      }

      Object.entries(activeFilters).forEach(([filter, filterValues]) => {
        if (filterValues.length > 0) {
          searchParams.set(filter, filterValues.join(","));
        }
      });
      if (modeQueryParameter) {
        searchParams.set("mode", modeQueryParameter);
      }
      const newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
      window.history.pushState(null, "", newURL);
    }

    /**
     * Update the filters state based on the URL.
     */
    function setFiltersFromURL() {
      const state = getStateFromURL();
      filters.forEach((filter) => {
        filter.checked = state[filter.name]?.includes(filter.value) || false;
        filter.setAttribute("aria-checked", state[filter.name]?.includes(filter.value) || "false");
      });

      if (globalFilterId && globalFilterId !== "global") {
        // Auto-select the product line if the global filter is set.
        document.querySelectorAll("input[name='productLine']").forEach((checkbox) => {
          if (globalFilter.productLines.includes(checkbox.value)) {
            checkbox.checked = true;
            checkbox.setAttribute("aria-checked", "true");
          }
        });
      }
    }

    /**
     * Toggle bool value on elements attribute.
     * @param {Element} element The element which attribute will be changed.
     * @param {string} attribute The attribute to be changed.
     */
    function toggleBoolAttribute(element, attribute) {
      if (element.getAttribute(attribute) == "false") {
        element.setAttribute(attribute, "true");
      } else {
        element.setAttribute(attribute, "false");
      }
    }

    // Update filters and URL when a filter is changed
    filters.forEach((filter) => {
      filter.addEventListener("change", () => {
        updateFilters();
        updateURL();
      });
    });

    // Set initial filters state.
    setFiltersFromURL();
    if (modeQueryParameter === "hideunselected") {
      // Do not show the product line in this mode.
      document.querySelectorAll(".filter-section")[0].style.display = "none";
    }
    updateFilters();
    updateCheckboxCount();

    // Mark all internal categories, and put them at the beginning.
    const tags = document.querySelectorAll(".card-category");
    tags.forEach((tag) => {
      if (tag.textContent.includes("Internal")) {
        tag.classList.add("internal");
        tag.parentElement.prepend(tag);
      }
    });
  }
})();
